<template>
    <PageRelatorio namePage="rel-financeiro-fluxo-caixa" title="Fluxo de caixa" subtitle="Informe o profissional e o período para obter os dados"
     permissions="" :fncCarregaRel="carregarRelatorio">

        <v-data-table class="tabela-rel-financeiro-fluxo-caixa" hide-default-footer :headers="colunasRel" :items="dadosRel"
         no-data-text="Nenhum registro encontrado" :items-per-page="-1" :header-props="{sortByText: 'Ordenar por...'}" />

    </PageRelatorio>
</template>

<script>
import PageRelatorio from '@/components/templates/PageRelatorio'
import consts from '@/globalFiles/consts'
import functions from '@/globalFiles/functions'
import axios from 'axios'

export default {
    name: 'RelFinFluxoCaixa',
    components: {
        PageRelatorio
    },
    data() {
        return {
            functions,
            dadosRel: [],
            colunasRel: [
                {
                    text: 'Tipo',
                    value: 'tipo'
                },
                {
                    text: 'Valor',
                    value: 'valor'
                }
            ]
        }
    },
    methods: {
        carregarRelatorio(profissional, dataIni, dataFim) {
            this.dadosRel = []

            axios.put(`${consts.baseApiUrl}/rel_fin_fluxo_caixa`, {
                    profissional: profissional,
                    data_ini: dataIni,
                    data_fim: dataFim
                })
                .then(r => {
                    this.dadosRel = r.data.data
                })
                .catch(err => {
                    functions.showError(err)
                })
        }
    }
}
</script>

<style>

</style>